<template>
  <div>
    <div
      class="flex justify-between items-center mb-8 bg-white bg-opacity-80 backdrop-blur sticky top-0 z-10 p-8"
    >
      <!-- Navigation Links -->
      <div class="space-x-6 text-2xl font-bold">
        <router-link
          :to="{ name: 'Home' }"
          :class="{ 'text-black': isActive('/feed'), 'text-gray-400': !isActive('/feed') }"
        >
          Feed
        </router-link>
        <router-link
          :to="{ name: 'Calendar' }"
          :class="{ 'text-black': isActive('/calendar'), 'text-gray-400': !isActive('/calendar') }"
        >
          Calendar
        </router-link>
        <router-link
          :to="{ name: 'CampaignPlanner' }"
          :class="{ 'text-black': isActive('/campaign-planner'), 'text-gray-400': !isActive('/campaign-planner') }"
        >
        Planner
        </router-link>
        <router-link
          :to="{ name: 'InsightsPromo' }"
          :class="{ 'text-black': isActive('/insights/promo'), 'text-gray-400': !isActive('/insights/promo') }"
        >
          Insights Promo
        </router-link>
        <router-link
          :to="{ name: 'InsightsEmail' }"
          :class="{ 'text-black': isActive('/insights/email'), 'text-gray-400': !isActive('/insights/email') }"
        >
          Insights Email
        </router-link>

      </div>

      <!-- Right Side Elements -->
      <div class="flex items-center space-x-4">
        <button
          class="bg-gradient-to-r from-fuchsia-600 to-purple-600 text-white px-4 py-2 rounded-md"
          @click="openAddCompetitorModal"
        >
          + Add Competitor
        </button>
        <button @click="signOut" class="text-gray-500 hover:text-black">
          Sign Out
        </button>
      </div>
    </div>

    <!-- Add Competitor Modal -->
    <AddCompetitorModal
      v-if="mainStore.isAddCompetitorModalOpen"
      @close="mainStore.closeAddCompetitorModal"
    />
  </div>
</template>

<script>
import { useMainStore } from "../stores/useMainStore";
import { useAuthStore } from "../stores/useAuthStore";
import { useRouter, useRoute } from "vue-router";
import AddCompetitorModal from "./AddCompetitorModal.vue";

export default {
  name: "TopNavigation",
  components: { AddCompetitorModal },
  setup() {
    const mainStore = useMainStore();
    const authStore = useAuthStore();
    const router = useRouter();
    const route = useRoute();

    const signOut = async () => {
      try {
        await authStore.signOut();
        router.push("/");
      } catch (error) {
        console.error("Error signing out:", error);
      }
    };

    const isActive = (path) => route.path === path;
    const openAddCompetitorModal = () => {
      mainStore.openAddCompetitorModal();
    };

    return {
      mainStore,
      signOut,
      route,
      isActive,
      openAddCompetitorModal,
    };
  },
};
</script>
